import type { PropsWithChildren } from 'react';

import * as B from './BoutiqueDeliveryInformation.styles';

interface BoutiqueDeliveryProps extends PropsWithChildren {
  loading: boolean;
  onClick?: () => void;
}

export const BoutiqueDeliveryInformation = ({
  loading,
  onClick,
}: BoutiqueDeliveryProps) => {
  return (
    <B.Wrapper $loading={loading} data-test-id='PriceInformationWrapper'>
      <B.Badge data-test-id='BoutiqueDeliveryBadge' onClick={onClick} />
    </B.Wrapper>
  );
};
